<template>
  <b-modal
    ref="phanXuLyYKien"
    title="Cập nhật phạm vi"
    size="xl"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
  >
    <b-tabs content-class="mt-3" v-model="tabIndex">
      <b-tab :active="false" title="Level">
        <p class="mb-2">
          <strong class="mr-5">Danh sách level</strong>
          <DataTable
            v-if="isShowLevel"
            :value="filterList(danhSachLevel || [])"
            :selection.sync="selectedLevel"
          >
            <Column
              field="label"
              dataKey="name"
              headerStyle="width: 40px"
              headerClass="p-2"
              header="Tên"
              bodyStyle="text-align: center"
            >
              <template #filter>
                <InputText
                  type="text"
                  class="p-column-filter"
                  placeholder="Tìm kiếm"
                  v-model="levelFilter"
                  @change="filterLevelList"
                />
              </template>
              <template #body="slotProps">
                <span>{{ slotProps.data.label }}</span>
              </template>
            </Column>
            <Column
              field="key"
              headerStyle="width: 40px"
              header=""
              bodyStyle="text-align: center"
              selectionMode="multiple"
            >
            </Column>
          </DataTable>
        </p>
      </b-tab>
      <b-tab :active="true" title="Đơn vị">
        <b-row class="phan-xu-ly">
          <b-col class="phong-ban" sm="12">
            <p
              v-if="!isLoading"
              class="mb-2 d-none"
              style="position: absolute; z-index: 999"
            >
              <strong class="mr-5">Danh sách đơn vị</strong>
            </p>
            <div
              v-if="isLoading"
              class="w-100 text-center"
              style="z-index: 9999"
            >
              <span class="ml-2 vertical-align-super"
                >Đang tải dữ liệu ...</span
              >
            </div>
            <div
              v-if="!isLoading && !dsTatCaDonViNoiBo"
              class="w-100 text-center"
            >
              <span class="vertical-align-super">Không có dữ liệu</span>
            </div>
            <template v-if="!isLoading">
              <DxTreeList
                :data-source="dsTatCaDonViNoiBo"
                :column-auto-width="true"
                :word-wrap-enabled="false"
                :show-borders="true"
                key-expr="id"
                parent-id-expr="iD_DonVi_Cha"
                :root-value="-1"
                :auto-expand-all="false"
              >
                <DxSearchPanel
                  :visible="true"
                  :width="240"
                  placeholder="Tìm kiếm"
                />
                <DxEditing
                  :allow-adding="false"
                  :allow-updating="true"
                  :allow-deleting="false"
                  mode="cell"
                />
                <DxColumn
                  :min-width="250"
                  data-field="tenDonVi"
                  caption="Đơn vị"
                  :allow-editing="false"
                >
                </DxColumn>
                <DxColumn
                  :visible="false"
                  data-field="keySearch"
                  :allow-editing="false"
                >
                </DxColumn>
                <DxColumn
                  :width="80"
                  cell-template="ChiDonVi"
                  caption="Chỉ đơn vị"
                  data-field="ChiDonVi"
                  data-type="boolean"
                  id="chu-tri"
                />
                <DxColumn
                  :width="120"
                  cell-template="CaDonViDuoi"
                  caption="Cả đơn vị dưới"
                  data-field="CaDonViDuoi"
                  data-type="boolean"
                  id="phoi-hop"
                />
                <template #ChiDonVi="{ data: options }">
                  <Checkbox
                    :value="options.data.ChiDonVi"
                    v-model="options.data.ChiDonVi"
                    :binary="true"
                    @change="onCellClick(options.data, true)"
                  />
                </template>
                <template #CaDonViDuoi="{ data: options }">
                  <Checkbox
                    v-if="options.data.hasDonViCon"
                    :value="options.data.CaDonViDuoi"
                    v-model="options.data.CaDonViDuoi"
                    :binary="true"
                    @change="onCellClick(options.data, false)"
                  />
                </template>
              </DxTreeList>
            </template>
          </b-col>
        </b-row>
      </b-tab>
      <b-tab :active="false" title="Cá nhân">
        <div class="mb-2">
          <div class="row align-items-center">
            <strong class="col col-6">Danh sách cán bộ</strong>
            <div class="col col-6">
              <div class="d-flex flex-1-0">
                <treeselect
                  :clearable="true"
                  :normalizer="normalizer"
                  :options="danhSachDonViBanDau || []"
                  :show-count="true"
                  :value="payloadCanBo.ID_DonVi"
                  no-children-text="Không có đơn vị con"
                  placeholder="Chọn đơn vị"
                  ref="chonCayDonVi"
                  v-model="payloadCanBo.ID_DonVi"
                  @input="getDanhSachCaNhan"
                  class="tree-don-vi flex-1-0"
                >
                  <label
                    :class="labelClassName"
                    slot="option-label"
                    slot-scope="{
                      node,
                      shouldShowCount,
                      count,
                      labelClassName,
                      countClassName,
                    }"
                  >
                    {{ node.label }}
                    <span
                      :class="countClassName"
                      v-if="shouldShowCount && count > 0"
                      >({{ count }})</span
                    >
                  </label>
                </treeselect>
                <b-form-checkbox
                  v-model="payloadCanBo.isGetAll"
                  class="mt-2 ml-3"
                  @change="onChangeGetAll"
                >
                  Tất cả
                </b-form-checkbox>
              </div>
            </div>
          </div>
          <DataTable
            class="mt-3"
            :value="(listCanBoPhanQuyen || {}).items || []"
            :selection.sync="selectedCaNhan"
            :loading="isLoadingTable"
          >
            <Column
              field="key"
              headerStyle="width: 45px"
              header=""
              bodyStyle="text-align: center"
              selectionMode="multiple"
            >
            </Column>
            <Column
              field="name"
              dataKey="name"
              headerStyle="minWidth: 140px"
              headerClass="p-2"
              header="Cá nhân"
              bodyStyle="text-align: left"
            >
              <template #filter>
                <InputText
                  type="text"
                  class="p-column-filter"
                  placeholder="Tìm kiếm"
                  v-model="payloadCanBo.HoTenFilter"
                  @change="getDanhSachCaNhan"
                />
              </template>
              <template #body="slotProps">
                <span>{{ slotProps.data.hoTen }}</span>
              </template>
            </Column>
            <Column
              filterMatchMode="custom"
              field="hoTen"
              header="Mã cán bộ"
              headerStyle="minWidth: 150px"
            >
              <template #body="slotProps">
                <span>{{ slotProps.data.maCanBo }}</span>
              </template>
              <template #filter>
                <InputText
                  type="text"
                  class="p-column-filter"
                  placeholder="Tìm kiếm"
                  v-model="payloadCanBo.MaCanBoFilter"
                  @change="getDanhSachCaNhan"
                />
              </template>
            </Column>
            <Column
              field="chucVu"
              dataKey="name"
              headerStyle="width: 140px"
              headerClass="p-2"
              header="Chức vụ"
              bodyStyle="text-align: left"
            >
              <template #filter>
                <InputText
                  type="text"
                  class="p-column-filter"
                  placeholder="Tìm kiếm"
                  v-model="payloadCanBo.ChucVuFilter"
                  @change="getDanhSachCaNhan"
                />
              </template>
              <template #body="slotProps">
                <span>{{ slotProps.data.chucVu }}</span>
              </template>
            </Column>
            <Column
              field="email"
              headerStyle="minWidth: 140px"
              headerClass="p-2"
              header="Email"
              bodyStyle="text-align: left"
            >
              <template #filter>
                <InputText
                  type="text"
                  class="p-column-filter"
                  placeholder="Tìm kiếm"
                  v-model="payloadCanBo.EmailFilter"
                  @change="getDanhSachCaNhan"
                />
              </template>
              <template #body="slotProps">
                <span>{{ slotProps.data.email }}</span>
              </template>
            </Column>
            <Column
              field="donVi"
              headerStyle="minWidth: 140px"
              headerClass="p-2"
              header="Đơn vị"
              bodyStyle="text-align: left"
            >
              <template #filter>
                <InputText
                  type="text"
                  class="p-column-filter"
                  placeholder="Tìm kiếm"
                  v-model="payloadCanBo.DonViFilter"
                  @change="getDanhSachCaNhan"
                />
              </template>
              <template #body="slotProps">
                <span>{{ slotProps.data.donVi }}</span>
              </template>
            </Column>
          </DataTable>
          <BasePagination
            :current-page="index"
            :total-pages="listCanBoPhanQuyen.totalPage"
            :total-rows="listCanBoPhanQuyen.totalCount"
            @changeNum="onChangeNum($event)"
            @changePages="onChangePages($event)"
          />
        </div>
      </b-tab>
    </b-tabs>

    <template v-slot:modal-footer>
      <div class="d-flex justify-content-end">
        <base-button
          id="phan-xu-ly"
          class="btn btn-blue"
          button="Xác nhận"
          icon="plus-circle-fill"
          :disabled="isLoadingButton"
          @click="submit"
        >
          Xác nhận
        </base-button>
        <base-button
          button="Đóng"
          class="btn ml-2 btn-orange"
          @click="dongModal()"
          >Đóng</base-button
        >
      </div>
    </template>
  </b-modal>
</template>

<script>
//import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import {
  DxTreeList,
  DxColumn,
  DxSearchPanel,
  DxEditing,
} from "devextreme-vue/tree-list";
import { mapGetters } from "vuex";
import {
  HELP_TEXT,
  ERROR_TEXT_TYPE,
  ERROR_TEXT_SIZE,
  ACCEPT_FILES,
  MAX_FILES,
  EMPTY_FILE_TEXT,
  LOI_UPLOAD_QUA_KICH_THUOC,
  MAX_SIZE,
} from "@/constants/uploadFiles";
import _isEmpty from "lodash/isEmpty";
import Checkbox from "primevue/checkbox";
import BasePagination from "@/components/common/BasePagination";
import { DOWN_LOAD_FILE, MANG_FILE_MODAL_FIELDS } from "@/constants/constants";
import _cloneDeep from "lodash/cloneDeep";
import { removeAccents } from "@/utils/normalize";
import { Treeselect } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

const DEFAULT_FORM = {
  NoiDung: "",
  HanXuLy: "",
};

export default {
  name: "XinYKienModal",
  components: {
    DxTreeList,
    DxColumn,
    DxSearchPanel,
    DxEditing,
    Checkbox,
    BasePagination,
    Treeselect
  },
  props: {
    id: {
      type: String,
      default: "",
    },
    chiTietPhanQuyen: {
      type: Object,
      default: () => {
        return {};
      },
    },
    actorId: {
      type: String,
      default: "",
    },
    actorType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      DOWN_LOAD_FILE,
      MANG_FILE_MODAL_FIELDS,
      HELP_TEXT: HELP_TEXT,
      ERROR_TEXT_TYPE: ERROR_TEXT_TYPE,
      ERROR_TEXT_SIZE: ERROR_TEXT_SIZE,
      ACCEPT_FILES: ACCEPT_FILES,
      MAX_FILES: MAX_FILES,
      EMPTY_FILE_TEXT: EMPTY_FILE_TEXT,
      LOI_UPLOAD_QUA_KICH_THUOC: LOI_UPLOAD_QUA_KICH_THUOC,
      MAX_SIZE: MAX_SIZE,
      phuongThucThongBao: [],
      filesUploadedArr: [],
      isLoading: true,
      isLoadingButton: false,
      isCheckFilSize: false,
      isLoadingAction: false,
      selectedRowsData: [],
      form: DEFAULT_FORM,
      searchField: "",
      listCanBoPhanQuyen: {},
      levelFilter: "",
      isShowLevel: true,
      payloadCanBo: {
        UserId: this.$route.params.id,
        HoTenFilter: "",
        MaCanBoFilter: "",
        ChucVuFilter: "",
        EmailFilter: "",
        DonViFilter: "",
      },
      mangPhuongThucThongBao: [
        { text: "SMS", value: "sms" },
        { text: "Email", value: "email" },
      ],
      index: 1,
      size: 10,
      tabIndex: 1,
      selectedLevel: [],
      selectedCaNhan: [],
      danhsach: null,
      isLoadingTable: false,
    };
  },
  computed: {
    ...mapGetters({
      danhSachLevel: "common/danhSachLevel",
      danhSachTatCaDonVi: "donVi/danhSachDonVi",
    }),
    danhSachDonViBanDau() {
      if (!this.danhSachTatCaDonVi) {
        return [];
      }
      let danhSach = [];
      danhSach = this.danhSachTatCaDonVi.map((item) => {
        return {
          Task_ID: item.id,
          Task_Parent_ID: item.iD_DonVi_Cha,
          Label: item.tenDonVi,
          Childrens: [],
          ...item,
        };
      });
      return this.list_to_tree(danhSach);
    },
    dsTatCaDonViNoiBo() {
      if (_isEmpty(this.danhSachTatCaDonVi)) return [];
      return this.danhSachTatCaDonVi.map((item) => {
        let donViFind =
          (this.chiTietPhanQuyen.listPhamVi || []).find(
            (dv) => dv.itemId === item.id
          ) || {};
        return {
          keySearch: `${removeAccents(item.Ten)} ${removeAccents(item.ChucVu)}`,
          ...item,
          ChiDonVi: donViFind.isDonViCon == false,
          CaDonViDuoi: donViFind.isDonViCon == true,
        };
      });
    },
    enablePXLBtn() {
      return (
        !_isEmpty(this.selectedRowsData) &&
        this.form.NoiDung &&
        !this.isLoadingAction
      );
    },
  },
  watch: {
    chiTietPhanQuyen: {
      handler() {
        let danhSachLevel = this.chiTietPhanQuyen.listPhamVi
          .filter((x) => x.isLevel)
          .map((x) => x.level);
        this.selectedLevel = this.danhSachLevel.filter((x) =>
          danhSachLevel.includes(x.key)
        );
      },
      deep: true,
    },
  },
  created() {
    this.layDanhSachLevel();
  },
  methods: {
    onChangeGetAll() {
      this.$nextTick(() => {
        this.getDanhSachCaNhan();
      });
    },
    list_to_tree(list) {
      if (list.length > 0) {
        var map = {},
          node,
          roots = [],
          i;
        for (i = 0; i < list.length; i += 1) {
          map[list[i].Task_ID] = i; // initialize the map
          list[i].Childrens = []; // initialize the children
        }
        for (i = 0; i < list.length; i += 1) {
          node = list[i];
          if (node.Task_Parent_ID !== this.guidEmpty) {
            // if you have dangling branches check that map[node.parentId] exists
            if (list[map[node.Task_Parent_ID]] != null) {
              list[map[node.Task_Parent_ID]].Childrens.push({
                id: node.Task_ID,
                label: node.Label,
                parentId: node.Task_Parent_ID,
                children: node.Childrens,
              });
            } else {
              roots.push({
                id: node.Task_ID,
                label: node.Label,
                parentId: node.Task_Parent_ID,
                children: node.Childrens,
              });
            }
          } else {
            roots.push({
              id: node.Task_ID,
              label: node.Label,
              parentId: node.Task_Parent_ID,
              children: node.Childrens,
            });
          }
        }
        return roots;
      }
      return list;
    },
    normalizer(node) {
      return {
        children: _isEmpty(node.children) ? undefined : node.children,
      };
    },
    filterLevelList() {
      this.isShowLevel = false;
      this.danhSachLevel.forEach((item) => {
        if (
          this.removeAccents(item.label, true).includes(
            this.removeAccents(this.levelFilter, true)
          )
        ) {
          item.isHide = false;
        } else {
          item.isHide = true;
        }
      });
      this.isShowLevel = true;
    },
    filterList(list) {
      return list.filter((key) => !key.isHide);
    },
    removeAccents(string, upperCase = false) {
      return removeAccents(string, upperCase);
    },
    layDanhSachLevel() {
      this.$store.dispatch("common/layDanhSachLevel");
    },
    onChangeNum(pageSize) {
      this.index = 1;
      this.size = pageSize;
      this.getDanhSachCaNhan();
    },
    onChangePages(page) {
      this.index = page;
      this.getDanhSachCaNhan();
    },
    submit() {
      let payload = {};
      this.isLoadingButton = true;
      if (this.tabIndex === 0) {
        payload = {
          ObjectPermissionType: "LEVEL",
          PermissionId: this.chiTietPhanQuyen.permissionId,
          ActorMappingId: this.chiTietPhanQuyen.actorMappingId,
          ActorId: this.actorId,
          ActorType: this.actorType,
          ListLevel: this.selectedLevel.map((x) => x.key),
        };
      } else if (this.tabIndex === 1) {
        payload = {
          ObjectPermissionType: "DON_VI",
          PermissionId: this.chiTietPhanQuyen.permissionId,
          ActorMappingId: this.chiTietPhanQuyen.actorMappingId,
          ActorId: this.actorId,
          ActorType: this.actorType,
          ListPhamVi: this.dsTatCaDonViNoiBo
            .filter((donVi) => donVi.ChiDonVi || donVi.CaDonViDuoi)
            .map((donVi) => {
              return {
                PhamViId: donVi.id,
                IsDonViCon: donVi.CaDonViDuoi,
              };
            }),
        };
      } else if (this.tabIndex === 2) {
        payload = {
          ObjectPermissionType: "CANBO_DEPARTMENT",
          PermissionId: this.chiTietPhanQuyen.permissionId,
          ActorMappingId: this.chiTietPhanQuyen.actorMappingId,
          ActorId: this.actorId,
          ActorType: this.actorType,
          ListCanBo: this.selectedCaNhan.map((x) => x.id),
        };
      }
      this.$store
        .dispatch("permission/addOrUpdateObjectPermisions", payload)
        .then((res) => {
          if (res.data.succeeded) {
            this.$toasted.clear();
            this.$toasted.global.showSuccessMessage({
              message: res.data.message,
            });
            this.isLoadingButton = false;
            this.$emit("refreshData");
            this.dongModal();
          } else {
            this.isLoadingButton = false;
            this.$toasted.clear();
            this.$toasted.global.showErrorMessage({
              message: res.data.message,
            });
          }
        })
        .catch(() => {
          this.isLoadingButton = false;
        });
    },
    getDanhSachCaNhan() {
      this.isLoadingTable = true;
      this.$store.dispatch("canBo/listCanBoPhanQuyen", {
        data: {
          actorMappingId: this.chiTietPhanQuyen.actorMappingId,
          ...this.payloadCanBo,
          pageIndex: this.index,
          pageSize: this.size,
        },
        onSuccess: (data) => {
          this.isLoadingTable = false;
          this.listCanBoPhanQuyen = data;
        },
      });
    },
    getPayloadByRole(role) {
      return this.selectedRowsData
        .filter((item) => item[role])
        .map((data) => {
          return {
            Id: data.Id,
            IsDonVi: data.Type === "DONVI",
          };
        });
    },
    removeItem(item) {
      const index = this.selectedRowsData.findIndex((x) => x.Ten === item.Ten);
      this.selectedRowsData.splice(index, 1);
      if (item) {
        this.dsTatCaDonViNoiBo.forEach((donVi) => {
          if (item.id === donVi.id) {
            donVi.ChiDonVi = false;
            donVi.CaDonViDuoi = false;
          }
        });
      }
    },
    formatChucVu(data) {
      if (data.ChiDonVi) return "Chỉ đơn vị";
      else if (data.CaDonViDuoi) return "Cả đơn vị dưới";
    },
    onCellClick(e, isChiDonVi) {
      this.dsTatCaDonViNoiBo.forEach((donVi) => {
        if (donVi.id === e.id) {
          if (isChiDonVi) {
            donVi.CaDonViDuoi = false;
          } else {
            donVi.ChiDonVi = false;
          }
        }
      });

      this.selectedRowsData = this.dsTatCaDonViNoiBo.filter(
        (donVi) => donVi.ChiDonVi || donVi.CaDonViDuoi
      );
    },
    dongModal() {
      this.$refs.phanXuLyYKien.hide();
    },
    showModal() {
      this.selectedLevel = [];
      this.selectedCaNhan = [];
      this.$refs.phanXuLyYKien.show();
      this.filesUploadedArr = [];
      this.selectedRowsData = [];
      this.phuongThucThongBao = [];
      this.form = _cloneDeep(DEFAULT_FORM);
      if (this.$refs.yKienXuLy) {
        this.$refs.yKienXuLy.fileRecords = [];
      }
      this.getUnitList();
      this.getDanhSachCaNhan();
    },
    getUnitList() {
      this.isLoading = true;
      this.isLoadingButton = true;
      this.$store.dispatch("donVi/layDanhSachDonViCha").then(() => {
        this.isLoading = false;
        this.isLoadingButton = false;
      });
    },
  },
};
</script>

<style lang="scss">
.width-20 {
  width: 20px;
}

.width-70 {
  width: 70px;
}

.phuong-thuc-title {
  margin-right: 4.3rem;
}

.dx-texteditor-container {
  .dx-icon {
    &.dx-icon-search {
      position: absolute;
      top: 50%;
      &:before {
        content: "";
        display: contents;
      }
    }
  }
}

.phan-xu-ly {
  .dx-row.dx-column-lines.dx-header-row {
    background: #ffff;
    color: #000;
    font-weight: 500;
  }
  .noi-dung {
    .ql-editor {
      min-height: 100px !important;
    }
  }
  .tblPhongBan {
    margin-left: 10px;
    .row-header,
    .row-body {
      display: flex;
      justify-items: center;
    }
    .row-header {
      background: #c9e4ea;
      color: white;
      text-align: center;
      padding: 5px 10px;
    }
    .row-body {
      border: 1px solid #ccc;
      padding: 5px;
    }
  }
  .phong-ban {
    max-height: 400px;
    overflow: auto;
  }
  .danh-sach-don-vi {
    max-height: 400px;
    overflow: auto;
  }
  .tbl-donvi {
    width: 100%;
    position: relative;
    th {
      top: 0;
      text-align: center;
      border: 1px solid #ddd;
      padding: 5px 10px;
      position: sticky;
      background: #c9e4ea;
      color: #000;
      font-weight: normal;
      border-bottom: 2px solid #ddd;
      border-top: 2px solid #ddd;
    }
    td {
      padding: 3px;
      border: 1px solid #ddd;
      font-size: 14px;
    }
  }
  .text-center {
    text-align: center;
  }
}
</style>
